import { Carousel } from "./Carousel";
import { propuestasItems } from "../data/propuestasData";

export function Propuestas() {
  return (
    <section>
      <h2>Propuestas</h2>
      <Carousel items={propuestasItems} />
    </section>
  );
}